import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StatesService } from '../state/states.service';

@Injectable({
  providedIn: 'root'
})
export class JobTaskService {

  constructor(private http: HttpClient, private statesService: StatesService) {
  }

  getAsyncExport(projectId: number,
                 locationsIds: string,
                 unit: string,
                 dataType: string,
                 startDate: string,
                 endDate: string,
                 offset: number,
                 fromSms: number) {
    return this.http.get(`job-tasks/export?` + locationsIds + `project_id=` + projectId + `&unit=` + unit +
      `&data_type=` + dataType + `&start_date=` + startDate + `&end_date=` + endDate + `&offset=` +
      offset + `&from_sms=` + fromSms);
  }

  getJobTasks( project_id: number, completed: boolean) {
    return this.http.get('job-tasks?level=' + this.statesService.stateLevel + '&project=' + project_id +
      (completed ? '&completed=1' : ''));
  }

  getJobTask(id: number) {
    return this.http.get(`job-tasks/` + id);
  }

  download(id: number) {
    return this.http.get(`job-tasks/download/` + id, {responseType: 'blob'});
  }

  delete(id: number) {
    return this.http.delete(`job-tasks/` + id);
  }
}
